export default __webpack_public_path__ + "static/media/Stage2.75ff2e29.jpg";